import { render, staticRenderFns } from "./CompanyView.vue?vue&type=template&id=06ae9815&scoped=true&"
import script from "./CompanyView.vue?vue&type=script&lang=js&"
export * from "./CompanyView.vue?vue&type=script&lang=js&"
import style0 from "./CompanyView.vue?vue&type=style&index=0&id=06ae9815&scoped=true&lang=css&"
import style1 from "./CompanyView.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ae9815",
  null
  
)

export default component.exports